import { request } from './config'

export type TReportSaleOrderParams = {
  startDate: string // ISO date string YYYY-MM-DD
  endDate: string   // ISO date string YYYY-MM-DD
  groupBy: string[] // e.g., ['customerCode','stt','itemGroupCode']
  customerCode?: string
}

export const getReportSaleOrder = (params: TReportSaleOrderParams, token: string) => {
  // Map groupBy array to repeated query params
  const queryParams: Record<string, any> = {
    startDate: params.startDate,
    endDate: params.endDate,
  }
  params.groupBy.forEach((g) => {
    if (!queryParams.groupBy) queryParams.groupBy = []
    queryParams.groupBy.push(g)
  })
  if (params.customerCode) queryParams.customerCode = params.customerCode

  return request({ url: 'report/sale-order', method: 'GET', params: queryParams }, { token })
}
